import React from 'react';

const IconBtnPlug = props =>
  <svg viewBox="0 0 22 22" {...props}>
    <path d="M15.498 3.496l-8.614 8.345l2.945 0.003l-3.327 6.66l8.614-8.346l-2.945-0.002L15.498 3.496z" />
  </svg>;

export default IconBtnPlug;
